import { IReportRow, IReportsParams } from '../../../types/reports';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';

export interface IPeriodReports {
  hourly: {
    current_period?: IReportRow[];
    previous_period?: IReportRow[];
    loading?: boolean;
  };
  daily: {
    current_period?: IReportRow[];
    previous_period?: IReportRow[];
    loading?: boolean;
  };
  monthly: {
    current_period?: IReportRow[];
    previous_period?: IReportRow[];
    loading?: boolean;
  };
}

export interface IPeriodReportFilters {
  comparedPeriod: COMPARED_PERIOD;
  startYearDate: number;
  endYearDate: number;
  days: IPickerOption[];
  months: IPickerOption[];
  hours: IPickerOption[];
}

export interface IDailyReportParams extends IReportsParams {
  days: number[];
}

export interface IMonthlyReportParams extends IReportsParams {
  months: number[];
}

export interface IHourlyReportParams extends IReportsParams {
  hours: string[];
}

export enum COMPARED_PERIOD {
  YEAR,
  MONTH,
}

export enum TIME_REPORTS_COMPARED_COLUMN {
  TIME_INTERVAL = 'time_interval',
  DAY_WEEK = 'day_of_the_week',
  MONTH = 'month',
}
